import { render, staticRenderFns } from "./Autodromo.vue?vue&type=template&id=5e54a15b&"
import script from "./Autodromo.vue?vue&type=script&lang=js&"
export * from "./Autodromo.vue?vue&type=script&lang=js&"
import style0 from "./Autodromo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports